import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearFilters } from "redux/SingleDataset/actions";
import { PRIVATE_DATASETS_PATH } from "helpers/constants/paths";
import TooltipWrapper from "views/uikit/TooltipWrapper";

import styles from "./style.module.scss";
import { isFastdupUser } from "helpers/utility/utilities";
import { setShowLearnMoreModal } from "redux/Modals/actions";
import { amplitudeTrack } from "helpers/utility/amplitude";
import { AMP_DATASET_EXPLORATION_EVENT__LEARN_MORE_MODAL__OPENED } from "helpers/constants/amplitudeEvents";

const DatasetIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M29.0911 27.5615L29.0911 19.7623C29.0911 18.4623 29.0911 18.4623 27.6364 18.4623L21.8181 18.4623C20.3634 18.4623 20.3634 18.4623 20.3634 19.7623L20.3634 27.5615C20.3634 28.8616 20.3634 28.8616 21.8181 28.8616L27.6364 28.8616C29.0911 28.8616 29.0911 28.8616 29.0911 27.5615ZM32 14.5625L32 9.36327C32 8.06325 32 8.06325 30.5458 8.06325L27.6369 8.06325C26.1822 8.06325 26.1822 8.06325 26.1822 9.36327L26.1822 14.5629C26.1822 15.8629 26.1822 15.8629 27.6369 15.8629L30.5458 15.8627C32 15.8625 32 15.8625 32 14.5625ZM17.4549 30.1609L17.4549 19.7623C17.4549 18.4623 17.4549 18.4623 16.0002 18.4623L4.36435 18.4623C2.90965 18.4623 2.90965 18.4623 2.90965 19.7623L2.90965 30.1609C2.90965 31.4609 2.90965 31.4609 4.36435 31.4609L16.0002 31.4609C17.4549 31.4609 17.4549 31.4609 17.4549 30.1609ZM8.72769 14.5625L8.72769 6.76323C8.72769 5.46321 8.72769 5.46321 7.27299 5.46321L1.4547 5.46321C1.23566e-07 5.46321 1.23566e-07 5.46321 1.54462e-07 6.76323L3.39818e-07 14.5625C3.70714e-07 15.8625 3.70714e-07 15.8625 1.4547 15.8625L7.27299 15.8625C8.72769 15.8625 8.72769 15.8625 8.72769 14.5625ZM23.2728 14.5625L23.2728 1.56394C23.2728 0.263916 23.2728 0.263916 21.8186 0.263916L13.0914 0.263916C11.6367 0.263916 11.6367 0.263916 11.6367 1.56394L11.6367 14.563C11.6367 15.8626 11.6367 15.8626 13.0914 15.8626L21.8186 15.8626C23.2728 15.8626 23.2728 15.8626 23.2728 14.5626L23.2728 14.5625Z"
        fill="currentColor"
      />
    </svg>
  );
};

const VLDatasetIcon = () => {
  const dispatch = useDispatch();
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const handleLearnMoreClick = () => {
    setIsTooltipOpen(false);
    dispatch(setShowLearnMoreModal(true));
    amplitudeTrack(AMP_DATASET_EXPLORATION_EVENT__LEARN_MORE_MODAL__OPENED);
  };
  const handleClick = () => {
    dispatch(clearFilters() as any);
  };

  const isActive = !isFastdupUser();

  return (
    <div className={styles.filterIcon}>
      <div
        data-tooltip-id="private-dataset-icon-tooltip"
        data-tooltip-place={isActive ? "right" : "bottom"}
        className={styles.datasetIcon}
      >
        {isActive ? (
          <Link to={PRIVATE_DATASETS_PATH} onClick={handleClick}>
            <DatasetIcon />
          </Link>
        ) : (
          <div className={styles.disabledIcon}>
            <DatasetIcon />
          </div>
        )}
      </div>
      <TooltipWrapper
        id="private-dataset-icon-tooltip"
        isClickable={true}
        isOpen={isTooltipOpen}
        setIsOpen={setIsTooltipOpen}
        maxWidth="390px"
      >
        <div className={styles.tooltipContent}>
          <div className={styles.tooltipText}>
            {isActive
              ? "My Datasets"
              : "The local version of visual layer only allows you to explore one dataset at a time"}
          </div>
          {!isActive && (
            <button
              className={styles.learnMoreButton}
              onClick={handleLearnMoreClick}
            >
              LEARN MORE
            </button>
          )}
        </div>
      </TooltipWrapper>
    </div>
  );
};

export default React.memo(VLDatasetIcon);
